export default {
  nav: {
    home: "Strona Główna",
    categories: "Kategorie",
    articles: "Artykuły",
    faq: "FAQ",
    contact: "Kontakt",
    browseSpreadsheet: "Przeglądaj Spreadsheet",
    buyNow: "Kup Teraz",
    kakobuySheet: "Kakobuy Sheet",
  },
  hero: {
    title: "Największy Kakobuy Spreadsheet Polska",
    subtitle: "Znajdź najlepsze produkty, sprawdzonych sprzedawców oraz codziennie aktualizowany Kakobuy Spreadsheet.",
    cta1: "Przeglądaj Spreadsheet",
    cta2: "Zobacz Najnowsze Produkty",
    stat1: "50 000+ produktów",
    stat2: "Codziennie aktualizowane",
    stat3: "Sprawdzeni sprzedawcy",
    stat4: "Darmowy dostęp",
  },
  why: {
    title: "Dlaczego warto korzystać z Kakobuy Spreadsheet?",
    items: [
      "Oszczędność czasu",
      "Najlepsze ceny",
      "Sprawdzeni sprzedawcy",
      "Codzienna aktualizacja",
      "Zdjęcia QC",
      "Wysyłka do Polski",
      "Darmowe zestawienia",
      "Ponad 100 kategorii",
    ],
  },
  categories: {
    title: "Popularne Kategorie",
    subtitle: "Przeglądaj nasze najlepsze kategorie produktów Kakobuy. Każda kategoria zawiera sprawdzone produkty i zaufanych sprzedawców.",
    viewCategory: "Zobacz Kategorię",
  },
  trust: {
    title: "Dlaczego nam ufać",
    items: [
      "Aktualizujemy Spreadsheet codziennie",
      "Sprawdzamy linki",
      "Monitorujemy sprzedawców",
      "Publikujemy poradniki",
      "Pomagamy początkującym",
      "Transparentne informacje",
      "Bezpieczne zakupy",
    ],
  },
  cta: {
    title: "Gotowy na najlepsze okazje?",
    subtitle: "Dołącz do tysięcy Polaków, którzy codziennie korzystają z Kakobuy Spreadsheet i znajdują najlepsze produkty w najlepszych cenach.",
    button: "Przejdź do Kakobuy Sheet",
  },
  footer: {
    aboutTitle: "O Nas",
    aboutText: "Kakobuy Finds to największy polski przewodnik po Kakobuy Spreadsheet. Pomagamy znaleźć najlepsze produkty i sprawdzonych sprzedawców.",
    quickLinks: "Szybkie Linki",
    contactTitle: "Kontakt",
    email: "kontakt@kakobuyfinds.work",
    copyright: "© 2026 Kakobuy Finds. Wszelkie prawa zastrzeżone.",
    privacy: "Polityka prywatności",
    terms: "Regulamin",
  },
  article: {
    readMore: "Czytaj więcej",
    backToHome: "← Powrót do strony głównej",
    relatedArticles: "Powiązane artykuły",
  },
};